import { getApi, postApi } from "../apiCall";

export const getPastList = (token, payload, user) => {
  let url = `${process.env.REACT_APP_API_URL}/${user}/capacity/getAll?current=true`;
  return postApi(url, payload);
};

export const getBidPlacedList = (token, capacityId) => {
  let url = `${process.env.REACT_APP_API_URL}/bidding/consumer/bid-placed?capacityId=${capacityId}`;
  return getApi(url);
};

export const getBidReceivedList = (token, capacityId) => {
  let url = `${process.env.REACT_APP_API_URL}/bidding/consumer/received?capacityId=${capacityId}&isHistory=true`;
  return getApi(url);
};

// export const getPastPlacedList = (token, capacityId) => {
//   let url = `${process.env.REACT_APP_API_URL}/bidding/consumer/bid-placed?capacityId=${capacityId}`;

//   let headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   return getApi(url, headers);
// };
